<template>
	<div class="component-index">
		<!-- <FunctionTitle :title="mainTitle" /> -->
		<CommonFlame :title="title" class="mt-2">
			<v-row no-gutters class="d-flex justify-space-between">
				<div class="d-flex flex-wrap-wrap">
					<v-select
						:items="years"
						label="選択年"
						v-model="selectedYear"
						@change="reloadIndex"
						style="max-width: 200px"
						class=""
					></v-select>
					<v-select
						:items="carModels"
						label="車種"
						v-model="selectedCarModel"
						@change="reloadIndex"
						multiple
						clearable
						style="max-width: 200px"
					></v-select>
				</div>
				<v-btn dark color="secondary" @click="goToNew">
					<v-icon class="mr-2">mdi-plus</v-icon>
					新規作成
				</v-btn>
			</v-row>
			<v-divider />
			<div>
				<div class="table-container px-2">
					<v-data-table
						locale="ja-JP"
						:headers="headers"
						:items="quotes"
						:mobile-breakpoint="240"
						hide-default-footer
						disable-filtering
						disable-pagination
						disable-sort
						no-data-text="データがありません。"
					>
						<template v-slot:item="{ item, index }">
							<LogiQuoteRecord
								:recordIndex="index"
								:record="item"
								@reloadIndex="reloadIndex"
								@showDetail="setSelectedRecord"
							/>
						</template>
					</v-data-table>
				</div>
			</div>
		</CommonFlame>
		<ShowDetailDialog
			ref="show"
			:record="selectedRecord"
			:dialog="showDialog"
			@closeDialog="showDialog = false"
			@reloadIndex="reloadIndex"
		/>
	</div>
</template>

<script>
import axios from "axios"
import moment from "moment/min/moment.min.js"
import Qs from "qs"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import rules from "../../helper/rules"

import CommonFlame from "../shared/CommonFlame.vue"
import FunctionTitle from "../shared/FunctionTitle.vue"
import LogiQuoteRecord from "./components/LogiQuoteRecord.vue"
import ShowDetailDialog from "./components/ShowDetailDialog.vue"

export default {
	components: {
		CommonFlame,
		FunctionTitle,
		LogiQuoteRecord,
		ShowDetailDialog,
	},
	data() {
		return {
			mainTitle: "",
			title: "運送費見積一覧",
			headers: [],
			quotes: [],
			years: [],
			selectedYear: {},
			selectedRecord: {},
			showDialog: false,
			selectedCarModel: [],
			carModels: [],
		}
	},
	filters: {
		dateFormatter: function (date) {
			if (!date) return ""
			return moment(date).format("YYYY/MM/DD")
		},
	},
	mounted() {
		let d = new Date()
		let thisYear = d.getFullYear()
		this.selectedYear = thisYear
		this.fetchQuotes(thisYear)
		this.setTableHeaders()
		const getYears = (start, end) => {
			const years = []
			for (let year = start; year <= end; year++) {
				years.push(year)
			}
			return years
		}
		const tenYearsAgo = thisYear - 10
		const tenYearsLater = thisYear + 10
		const yearsArray = getYears(tenYearsAgo, tenYearsLater)
		this.years = yearsArray
	},
	methods: {
		setSelectedRecord(record) {
			console.log(record)
			this.selectedRecord = record
			this.showDialog = true
		},
		goToNew() {
			this.$router.push({ name: "logi_quotes_new" })
		},
		reloadIndex() {
			this.fetchQuotes(this.selectedYear)
		},
		fetchQuotes(year) {
			const headers = authenticate.setHeader()
			axios
				.get(`/erp/v1/logi_quotes`, {
					params: { year: year, selected_car_model: this.selectedCarModel },
					headers,
				})
				.then((res) => {
					this.quotes = res.data.quotes
					this.carModels = res.data.car_models
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		setTableHeaders() {
			this.headers = [
				{
					text: "見積番号",
					value: "quote_number",
					width: "120px",
					filter: null,
					class: "px-1 font-size-075rem",
				},
				{
					text: "都道府県",
					value: "prefecture",
					width: "120px",
					filter: null,
					class: "px-1 font-size-075rem",
				},
				{
					text: "市町村",
					value: "city",
					width: "150px",
					filter: null,
					class: "px-1 font-size-075rem",
				},
				{
					text: "車種",
					value: "car_model",
					width: "150px",
					filter: null,
					class: "px-1 font-size-075rem",
				},
				{
					text: "オーナミ",
					value: "onami",
					width: "90px",
					filter: null,
					class: "px-1 font-size-075rem",
				},
				{
					text: "日本ロジコム",
					value: "japan_logicom",
					width: "100px",
					filter: null,
					class: "px-1 font-size-075rem",
				},
				{
					text: "城南運輸",
					value: "jonan_unyu",
					width: "90px",
					filter: null,
					class: "px-1 font-size-075rem",
				},
				{
					text: "太田貨物",
					value: "ota_kamotsu",
					width: "90px",
					filter: null,
					class: "px-1 font-size-075rem",
				},
				{
					text: "マルカ運輸",
					value: "maruka_unyu",
					width: "90px",
					filter: null,
					class: "px-1 font-size-075rem",
				},
				{
					text: "赤帽",
					value: "akabou",
					width: "90px",
					filter: null,
					class: "px-1 font-size-075rem",
				},
				{
					text: "見積日",
					value: "quote_date",
					width: "90px",
					filter: null,
					class: "px-1 font-size-075rem",
				},
				{
					text: "回答日",
					value: "answer_date",
					width: "90px",
					filter: null,
					class: "px-1 font-size-075rem",
				},
				{
					text: "備考",
					value: "remarks",
					width: "200px",
					filter: null,
					class: "px-1 font-size-075rem",
				},
				{
					text: "紐付いた案件",
					value: "remarks",
					width: "90px",
					filter: null,
					class: "px-1 font-size-075rem",
				},
			]
		},
	},
	computed: {},
}
</script>
